<template>
  <content-loader :height="310">
    <rect x="0" y="0" rx="3" ry="3" width="160" height="40" />
    <rect x="180" y="0" rx="3" ry="3" width="220" height="40" />
    <rect x="420" y="0" rx="3" ry="3" width="40" height="40" />
    <rect x="0" y="60" rx="3" ry="3" width="280" height="40" />
    <rect x="300" y="60" rx="3" ry="3" width="160" height="40" />
    <rect x="0" y="120" rx="3" ry="3" width="200" height="40" />
    <rect x="220" y="120" rx="3" ry="3" width="140" height="40" />
    <rect x="380" y="120" rx="3" ry="3" width="80" height="40" />
    <rect x="0" y="180" rx="3" ry="3" width="260" height="40" />
    <rect x="280" y="180" rx="3" ry="3" width="180" height="40" />
    <rect x="0" y="240" rx="3" ry="3" width="200" height="40" />
    <rect x="220" y="240" rx="3" ry="3" width="140" height="40" />
    <rect x="380" y="240" rx="3" ry="3" width="80" height="40" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
